import React from "react";
import { useNavigate } from "react-router-dom";

export default function FieldAccessPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <h1 style={{ marginTop: 0 }}>Field Access</h1>
        <p>Select a login type.</p>

        <div style={styles.grid}>
          <button style={styles.button} onClick={() => navigate("/field-access/responder")}>
            Responder Login
          </button>

          <button style={styles.button} onClick={() => navigate("/field-access/hq")}>
            HQ Login
          </button>

          <button style={styles.button} onClick={() => navigate("/field-access/dispatch")}>
            Dispatch Login
          </button>

          <button style={styles.button} onClick={() => navigate("/field-access/command")}>
            Command Login
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f8fafc",
    padding: 24,
  },
  card: {
    width: "100%",
    maxWidth: 900,
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
    marginTop: 20,
  },
  button: {
    padding: "24px 20px",
    borderRadius: 14,
    border: "1px solid #dbe4ee",
    background: "#fff",
    cursor: "pointer",
    fontSize: 18,
    fontWeight: 700,
  },
};